import { render, staticRenderFns } from "./orderTabs.vue?vue&type=template&id=78f735fc&"
import script from "./orderTabs.vue?vue&type=script&lang=js&"
export * from "./orderTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78f735fc')) {
      api.createRecord('78f735fc', component.options)
    } else {
      api.reload('78f735fc', component.options)
    }
    module.hot.accept("./orderTabs.vue?vue&type=template&id=78f735fc&", function () {
      api.rerender('78f735fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shop/orderList/component/orderTabs.vue"
export default component.exports